import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, ApiVisa, PagingResponseModel, BasicApiResponseModel } from '../../shared';
import { Core2Config } from '../../shared';
import { ItemPointLinkContainerModel } from '../../../../../../models/aggregates/crm/item-point-link';


@Injectable({
  providedIn: 'root'
})
export class ItemPointLinkService extends BaseApiTemplateService<ItemPointLinkContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + 'pricing-scheme-point-links';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + 'pricing-scheme-point-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + 'pricing-scheme-point-links';
    this.httpClient = http;
  }


}


